module.exports = __webpack_public_path__ + "static/media/evenement.3b1eefa3.webp";